import React from "react";
import "./styles.css";

export const Footer: React.FC = () => {
  return (
    <div className="footer">
      <div className="support">技术支持：南京伯索网络科技有限公司</div>
      <div className="rightCode">苏ICP备13015631号</div>
    </div>
  );
};
